module.exports = __webpack_public_path__ + "img/quatre.1502f2bb.png";